import { Pagination, Popover } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useEffect } from "react";
import axios from "axios";
import { useState } from "react";

const Paget = ({data}) => {
  console.log(data)
  const token = useSelector((state) => state.token);
  const totalPages = 1;
  const [page, setPage] = useState(1);
  const [pensioners, setPensioners] = useState([]);
  const [refetch, setRefetch] = useState(false);
  const [show, setShow] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const router = useNavigate();
  const dispatch = useDispatch();
  // const option2 = useSelector((state) => state.option2);
  let wow = [];
  for (let i = 0; i <= 5; i++) {
    wow.push(i);
  }
  const pageHandler = (e) => {
    setPage(e);
  };
  const columnHeaders = [
    "Sr. No",
    "Product",
    "Inventory",
    "Item Code",
    "Rate",
    "Inventory Cost",
  ];



  return (
    <>
     {/* table */}
     <div className="overflow-x-auto custom-scrollbar bg-white  relative shadow-md sm:rounded-lg overflow-hidden border-2 border-gray-50">
            {data.length === 0 ? (
              <h1 className="text-center text-[1.1rem] p-5 h-40">
                No Data Found
              </h1>
            ) : (
              <table className="w-full text-sm text-left text-gray-500  ">
                <thead className="text-xs text-gray-700 uppercase bg-primary text-white">
                  <tr>
                    {columnHeaders.map((columnHeader, index) => (
                      <th
                        key={index}
                        scope="col"
                        className="px-6 py-3 font-semibold tracking-wider"
                      >
                        {columnHeader}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {data?.map((pen, index) => (
                    <tr
                      key={index}
                       // onClick={() => {
                      //   router(
                      //     "/SuperAdmin/Inventory/PurchasedProducts/Detail"
                      //   );
                      // }}
                      className={`border-b border-[1px] border-[#d9d9d970] hover:bg-gray-200 text-md cursor-pointer  ${
                        index % 2 === 0 ? "bg-white" : "bg-[#f2faf9]"
                      }`}
                      
                    >
                      <th
                        scope="row"
                        className="px-3 py-5 font-medium text-gray-900  whitespace-nowrap ml-12"
                      >
                        
                        {index+1}.
                      </th>

                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <div className="flex-shrink-0 h-10 w-10">
                            <img
                              className="h-10 w-10 rounded-full border-2 border-primary"
                              src={
                                pen?.invProduct?.invproductgallaries?.find(
                                  (gallery) => gallery?.isCoverImg
                                )?.image
                                  ? pen?.invProduct?.invproductgallaries?.find(
                                      (gallery) => gallery?.isCoverImg
                                    )?.image
                                  : "https://t3.ftcdn.net/jpg/03/45/05/92/360_F_345059232_CPieT8RIWOUk4JqBkkWkIETYAkmz2b75.jpg"
                              }
                              alt=""
                            />
                          </div>
                          <div className="ml-4">
                            {pen?.invProduct?.name}
                          </div>
                        </div>
                      </td>
                    
                      <td className="px-6  py-5"> {pen?.totalActualUnits === null ? "----" : `${pen?.totalActualUnits}`}</td>
                      <td className="px-6  py-5 ">
                      {pen?.prodItemCode}
                      </td>
                     
                      <td
                        className="px-6  py-5"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        ${pen?.price}
                      </td>
                      
                     
                      <td className="px-6  py-5">
                      ${pen?.totalAmount}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
    <section className="mt-4">
      <div className="mx-auto max-w-screen-3xl">
        <div className="bg-white  relative shadow-md sm:rounded-lg overflow-hidden border-2 border-gray-50 ">
          {/* table */}
          {/* <div className="overflow-x-auto custom-scrollbar">
            {data?.length === 0 ? (
              <h1 className="text-center text-[1.1rem] p-5 h-40">
                No Data Found
              </h1>
            ) : (
              <table className="w-full text-sm  text-gray-500  ">
                <thead className="text-xs  uppercase bg-primary text-white">
                  <tr>
                    {columnHeaders.map((columnHeader, index) => (
                      <th
                        key={index}
                        scope="col"
                        className="px-6 py-3 font-semibold tracking-wider"
                      >
                        {columnHeader}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {data?.map((pen, index) => (
                    <tr
                      key={index}
                      className={`border-b border-[1px] border-[#d9d9d970] hover:bg-gray-200 text-md cursor-pointer text-center ${
                        index % 2 === 0 ? "bg-white" : "bg-[#f2faf9]"
                      }`}
                      // onClick={() => {
                      //   router(
                      //     "/SuperAdmin/Inventory/PurchasedProducts/Detail"
                      //   );
                      // }}
                    >
                      <th
                        scope="row"
                        className="px-3 py-5 font-medium text-gray-900  whitespace-nowrap"
                      >
                        {index+1}.
                      </th>

                      <td className="px-3 py-4 whitespace-nowrap ">
                        <div className="flex items-center ">
                          <div className="flex-shrink-0 h-10 w-10 text-center">
                            <img
                              className="h-10 w-10 rounded-full border-2 border-primary"
                              src={
                                pen?.invProduct?.invproductgallaries?.find(
                                  (gallery) => gallery?.isCoverImg
                                )?.image
                                  ? pen?.invProduct?.invproductgallaries?.find(
                                      (gallery) => gallery?.isCoverImg
                                    )?.image
                                  : "https://t3.ftcdn.net/jpg/03/45/05/92/360_F_345059232_CPieT8RIWOUk4JqBkkWkIETYAkmz2b75.jpg"
                              }
                              alt=""
                            />
                          </div>
                          <div className="ml-4 text-center">{pen?.invProduct?.name}</div>
                        </div>
                      </td>

                      <td className="px-2 py-4">
                        {pen?.totalActualUnits === null ? "----" : `${pen?.totalActualUnits}`}
                      </td>

                      <td className="px-2 py-4">{pen?.invProduct?.pricingUnit}</td>
                      <td className="px-2 py-4">{pen?.price}</td>
                      <td className="px-2 py-4">{pen?.totalAmount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div> */}
          {/* <nav
            className="flex flex-col md:flex-row justify-center items-start md:items-center space-y-3 md:space-y-0 p-4"
            aria-label="Table navigation"
          >
            <span className="text-sm font-normal text-gray-500 ">
              Showing{" "}
              <span className="font-semibold text-gray-900">Page {page} </span>
              of{" "}
              <span className="font-semibold text-gray-900">{totalPages}</span>
            </span>
            <div className={`flex justify-end mt-7`}>
              <Pagination
                defaultCurrent={1}
                // total={totalPages * 10}
                // showSizeChanger={false}
                // onChange={pageHandler}
                // current={search ? pagewithsearch : page}
              />
            </div>
          </nav> */}
        </div>
      </div>
    </section>
    </>

  );
};

export default Paget;
